import { COURIER_DELIVERY_ID, PICKUP_DELIVERY_ID } from '@constants/delivery';

export const PICKUP_ID = PICKUP_DELIVERY_ID;
export const DELIVERY_ID = COURIER_DELIVERY_ID;
export const MAP_ZOOM = 10;

// Stable identity for the store search filter (avoids useMemo re-computation).
export const SHOP_NAME_KEYS = ['title', 'address'] as const;

export { StoreTypeTitles } from '../shared/storeTypes';
